/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import IErrorHandler from './IErrorHandler';
import SentryErrorHandler from './SentryErrorHandler';
import { StubErrorHandler } from './StubErrorHandler';

export enum Category
{
    State = "State"
}

export default class ErrorHandler
{
    private static _errorHandler: IErrorHandler = null;
    public static get Instance(): IErrorHandler
    {
        if (!ErrorHandler._errorHandler) {
            // tslint:disable:no-string-literal
            if (cc.sys.isBrowser && window["raven"])
            {
                ErrorHandler._errorHandler = new SentryErrorHandler();
            }
            else
            {
                ErrorHandler._errorHandler = new StubErrorHandler();
            }
        }

        return ErrorHandler._errorHandler;
    }
}
